export const COMMON_ERROR_TITLE = 'Ошибка выполнения операции';
export const COMMON_ERROR_BODY =
  'При выполнении операции произошла непредвиденная ошибка. Пожалуйста, повторите попытку позже или обратитесь в службу технической поддержки.';

export const INTERNAL_SERVER_ERROR = 500;
export const MESSAGE_ERROR = 'MESSAGE';
